import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface StopSurveyFieldsProps extends React.SVGProps<SVGSVGElement> {
  isSelected?: boolean;
}

export default function StopSurveyFields({ isSelected = false, style, onClick }: StopSurveyFieldsProps) {
  return (
    <SvgIcon onClick={onClick} viewBox="0 0 26 26" style={{ width: `24px`, height: `24px`, ...(style ?? {}) }}>
      <g>
        {!isSelected ? (
          <g>
            <path
              fill={RoutalPalette.neutral60}
              d="m20.83,25.77H5.16c-2.63,0-4.77-2.14-4.77-4.77V5.01C.39,2.38,2.53.23,5.16.23h15.67c2.63,0,4.78,2.14,4.78,4.77v15.98c0,2.63-2.14,4.77-4.78,4.77ZM5.16,1.23c-2.08,0-3.77,1.69-3.77,3.77v15.98c0,2.08,1.69,3.77,3.77,3.77h15.67c2.08,0,3.78-1.69,3.78-3.77V5.01c0-2.08-1.69-3.77-3.78-3.77H5.16Z"
            />
            <path
              fill={RoutalPalette.neutral60}
              d="m13.48,7.28l1.55,3.11c.08.16.23.27.4.29l3.46.5c.14.02.27.09.35.2.09.11.12.25.1.39-.02.11-.07.22-.16.3l-2.51,2.43c-.13.12-.18.29-.15.46l.6,3.43c.04.28-.15.55-.44.6-.12.02-.24,0-.34-.05l-3.09-1.61c-.15-.08-.34-.08-.5,0l-3.11,1.63c-.26.13-.58.03-.72-.22-.05-.1-.07-.22-.05-.33l.6-3.43c.03-.17-.03-.34-.15-.46l-2.53-2.43c-.21-.21-.21-.54,0-.74.08-.08.19-.13.3-.15l3.46-.5c.17-.03.32-.14.4-.29l1.55-3.11c.06-.13.17-.22.31-.27.13-.04.28-.03.41.03.1.05.19.14.24.24Z"
            />
          </g>
        ) : (
          <g>
            <path
              fill={RoutalPalette.primary40}
              d="m21.15.23H4.85C3.31.23,1.96,1.01,1.16,2.2c-.48.71-.76,1.57-.76,2.49v16.63c0,.92.28,1.78.76,2.49.23.34.52.64.84.9.77.65,1.76,1.06,2.85,1.06h16.31c1.23,0,2.34-.5,3.15-1.3s1.3-1.92,1.3-3.15V4.68c0-2.46-1.99-4.45-4.45-4.45Z"
            />
            <path
              fill={RoutalPalette.neutral00}
              d="m13.48,7.28l1.55,3.11c.08.16.23.27.4.29l3.46.5c.14.02.27.09.35.2.09.11.12.25.1.39-.02.11-.07.22-.16.3l-2.51,2.43c-.13.12-.18.29-.15.46l.6,3.43c.04.28-.15.55-.44.6-.12.02-.24,0-.34-.05l-3.09-1.61c-.15-.08-.34-.08-.5,0l-3.11,1.63c-.26.13-.58.03-.72-.22-.05-.1-.07-.22-.05-.33l.6-3.43c.03-.17-.03-.34-.15-.46l-2.53-2.43c-.21-.21-.21-.54,0-.74.08-.08.19-.13.3-.15l3.46-.5c.17-.03.32-.14.4-.29l1.55-3.11c.06-.13.17-.22.31-.27.13-.04.28-.03.41.03.1.05.19.14.24.24Z"
            />
          </g>
        )}
      </g>
    </SvgIcon>
  );
}
